import { SnapStatus } from '@/consts/snapshot'

/**
 * Snapshot status codes mapping for filtering
 */
export const SNAPSHOT_STATUS_CODES = {
  all: [SnapStatus.Finished, SnapStatus.Deleting, SnapStatus.Resumable] as number[],
  available: [SnapStatus.Finished] as number[],
  restorable: [SnapStatus.Deleting, SnapStatus.Resumable] as number[],
}

/**
 * Convert status filter selections to SnapStatus codes
 * @param selected - Array of selected status filters ('all', 'available', 'restorable')
 * @returns Array of SnapStatus codes
 */
export function getStatusCodes(selected: (string | number)[]): number[] {
  if (selected.includes('all')) {
    return [...SNAPSHOT_STATUS_CODES.all]
  }

  const codes: number[] = []
  if (selected.includes('available')) {
    codes.push(...SNAPSHOT_STATUS_CODES.available)
  }
  if (selected.includes('restorable')) {
    codes.push(...SNAPSHOT_STATUS_CODES.restorable)
  }
  return codes
}
